import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { api } from "../../lib/api";

export const XmasBanner = () => {
  const [on, setOn] = useState(false);
  useEffect(() => { api.get("/settings").then((r) => setOn(r.data.xmas_banner)).catch(() => {}); }, []);
  if (!on) return null;
  return (
    <Link to="/design" className="block bg-[#0c2a1f] text-white transition-colors hover:bg-[#123a2b]" data-testid="home-xmas-banner">
      <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-4 gap-y-1 px-4 py-3 text-center text-sm sm:text-base">
        <Gift className="h-5 w-5 text-red-400" />
        <span className="font-display font-extrabold uppercase">Order <span className="text-lime-300">early</span> for Christmas delivery</span>
        <span className="text-slate-200">to avoid disappointment</span>
        <span className="font-bold underline decoration-lime-400 underline-offset-4">Design yours →</span>
      </div>
    </Link>
  );
};
